import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import {
  ConverterService,
  Country,
  COUNTRY_NORMALIZER,
  LanguageService,
  LoggerService,
  normalizeHttpError,
  Occ,
  OccEndpointsService
} from '@spartacus/core'
import { Observable, throwError } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import { CUSTOMER_INFO_NORMALIZER } from '../../converters/eb-common-converters'
import { EbPersonalInfoInterface } from '../../interfaces/eb-common-form.interface'

@Injectable()
export class EbCommonFormAdapter {

  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
    protected languageService: LanguageService
  ) {}

  getCustomerInfo(userId): Observable<EbPersonalInfoInterface> {
    return this.http
      .get(this.occEndpoints.buildUrl('customerInfo', { urlParams: { userId } }))
      .pipe(
        catchError(error => throwError(() => normalizeHttpError(error, this.logger))),
        this.converter.pipeable(CUSTOMER_INFO_NORMALIZER)
      )
  }

  getCountries(): Observable<Country[]> {
    return this.languageService.getActive().pipe(
      switchMap(() =>
        this.http.get<Occ.CountryList>(this.occEndpoints.buildUrl('contactUsCountries')).pipe(
          map(countryList => countryList.countries),
          this.converter.pipeableMany(COUNTRY_NORMALIZER)
        )
      )
    )
  }
}
